import React from 'react';
import '../scss/components/_videoEmbed.scss';
import ReactPlayer from 'react-player';
import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed';

const VideoEmbed = ({ url, autoplay = false, ownClass }) => {
  return (
    <div className={`${ownClass ? ownClass : ''} career-video`}>
      <ResponsiveEmbed aspectRatio="16by9">
        <ReactPlayer
          url={url}
          playing={autoplay}
          volume={1}
          controls={true}
          width='100%'
          height='100%'
        />
      </ResponsiveEmbed>
    </div>
  )
};

export default VideoEmbed;